import parseDialogue from "../../util/parseDialogue";

export const SuperphreakD6 = parseDialogue(`
superphreak:d6:100-700

#100 ~~~~ ~~~~ ~ ~~~~ It's ~~~~~~~~ harder and harder to stay ~~~~~ ~~~ but I've got important information ~~~~ ~~~~ Ready?
>200 Go ahead.

#200 I finished my trace on Disarray. Surprise surprise, he's the source ~~ ~~~~ ~~~ corrupt programs and security screw-ups. Disarray's been infiltrating ~~~~~~~ ~~~~~ ~~~ the web. I don't know why.
>300 What about that program he took?
>300 What about that node he's in?

#300 ~~~~ ~~~~~~ a well-guarded communications hub. He's using the stolen program ~~~ ~~~~~ access all the nodes on the net ~~~ ~~~~~ I just don't understand the point. Any ideas?
>400 Does nightfall mean anything to you?

#400 Nightfall? What does that mean?
>500 Disarray's secret project?

#500 Nightfall... That's it! Disarray's ~~~~~ ~~~ use his nightfall program to black out the net. Total midnight! ~~~~ ~~~~~~ ~~~ crash the entire system! You have to stop him!
>600 How?

#600 Get ~~~~~~~ ~~ his personal node. Defeat the security, ~~~~ deactivate the nightfall program and hurry. ~~~ ~~~~ have much time!
>700 I'm on it!
`);
